// npm packages
import React, { useState } from "react";
import {
  Typography,
  TextField,
  Button,
  Grid,
  FormControl,
  FormHelperText,
  Select,
  MenuItem,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Loader from "react-loader";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

// components
import MainLayout from "../components/hoc/MainLayout";
import LocationAutocomplete from "../components/LocationAutocomplete";

// helpers
// import validateEmail from "../helpers/validateEmail";
import { apiPost } from "../helpers/api";

const useStyles = makeStyles((theme) => ({
  form: {
    width: "100%", // Fix IE 11 issue.
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: "#A3080C",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#bd0d12",
      borderColor: "#564345",
    },
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  phoneContainer: {
    marginTop: "16px !important",
  },

  phoneInput: {
    font: "inherit",
    color: "currentColor",
    width: "90% !important",
    border: "0",
    height: "40px !important",
    margin: "0",
    marginTop: "16px !important",
    display: "block",
    padding: "6px 0 7px",
    minWidth: "0",
    background: "none",
    boxSizing: "content-box",
    animationName: "mui-auto-fill-cancel",
    letterSpacing: "inherit",
    animationDuration: "10ms",
  },
  formControl: {
    // margin: theme.spacing(1),
    width: "100%",
    // minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

function NewDelivery(props) {
  const classes = useStyles();

  const valuesObject = {
    orderId: "",
    contactInfo: "",
    contactNumber: "",
    contactEmail: "",
    landmark: "",
    location: "",
    map: "",
    type: "delivery",
  };

  const [values, setValues] = useState(valuesObject);
  const [errors, setErrors] = useState(valuesObject);
  const [loaded, setLoaded] = useState(true);

  const validateForm = () => {
    // clear errors
    setErrors(valuesObject);

    let hasErrors = false;
    // validate form
    Object.keys(values).forEach((key) => {
      if (!["contactEmail", "landmark"].includes(key)) {
        const mapArray = ["map", "location"];
        if (
          !mapArray.includes(key) ||
          (mapArray.includes(key) && values.type === "delivery")
        ) {
          // make sure everything is filled out
          if (values[key]?.trim() === "") {
            setErrors((prevErrors) => ({
              ...prevErrors,
              [key]: "This field is required.",
            }));
            hasErrors = true;
          }
        }
      }
    });

    return !hasErrors;
  };

  const formHandler = async (e) => {
    e.preventDefault();
    setLoaded(false);

    if (validateForm()) {
      // get latitude and longitude data
      const mapArray = values.map.split(",");

      try {
        const dataObj = {
          order_id: values.orderId,
          name: values.contactInfo,
          email_address: values.contactEmail,
          mobile_number: values.contactNumber,
          landmark: values.landmark,
          address: values.location,
          is_pickup: values.type === "pickup",
        };
        if (values.type === "delivery") {
          dataObj.latitude = mapArray[0];
          dataObj.longitude = mapArray[1];
        }

        // send data to api endpoint
        const response = await apiPost("/deliveries", dataObj);

        if (response.data.data) {
          if (dataObj.is_pickup) {
            props.history.push("/");
          } else {
            props.history.push(`/delivery/${response.data.data.id}`);
          }
        }
      } catch (err) {
        console.log(err.response?.data?.message);
        setLoaded(true);
      }
    } else {
      setLoaded(true);
    }
  };

  const renderTextField = (
    id,
    label,
    fieldName,
    fieldType = "text",
    isRequired = true
  ) => {
    return (
      <TextField
        variant="outlined"
        margin="normal"
        required={isRequired}
        fullWidth
        id={id}
        label={label}
        autoFocus={fieldName === "orderId"}
        type={fieldType}
        value={values[fieldName]}
        error={!!errors[fieldName]}
        helperText={errors[fieldName]}
        onChange={(e) =>
          setValues((prevValues) => ({
            ...prevValues,
            [fieldName]: e.target.value,
          }))
        }
      />
    );
  };

  return (
    <Loader loaded={loaded}>
      <Typography variant="h5" gutterBottom>
        Add Transaction
      </Typography>
      <form className={classes.form} onSubmit={formHandler}>
        <FormControl variant="outlined" className={classes.formControl}>
          <Select
            labelId="demo-simple-select-outlined-label"
            id="demo-simple-select-outlined"
            value={values.type}
            onChange={(e) =>
              setValues((prevValues) => ({
                ...prevValues,
                type: e.target.value,
              }))
            }
          >
            <MenuItem value="delivery">Order Type: Delivery</MenuItem>
            <MenuItem value="pickup">Order Type: Pick-up</MenuItem>
          </Select>
        </FormControl>
        {renderTextField("orderId", "Order ID", "orderId")}
        {renderTextField("contactInfo", "Contact Person", "contactInfo")}
        <Grid container spacing={3}>
          <Grid item xs={6} style={{ paddingRight: "20px" }}>
            {/* {renderTextField(
              "contactNumber",
              "Contact Number",
              "contactNumber"
            )} */}

            <PhoneInput
              disableDropdown={
                process.env.REACT_APP_COUNTRYCODES?.split(",").length === 1
              }
              containerClass={classes.phoneContainer}
              inputClass={classes.phoneInput}
              countryCodeEditable={false}
              country={process.env.REACT_APP_COUNTRYCODE}
              onlyCountries={process.env.REACT_APP_COUNTRYCODES?.split(",")}
              value={values.contactNumber}
              masks={{ ca: "..........", ph: "(...) ...-...." }}
              onChange={(value) =>
                setValues((prevValues) => ({
                  ...prevValues,
                  contactNumber: value,
                }))
              }
            />

            <FormControl
              required
              error={!!errors.contactNumber}
              component="fieldset"
            >
              <FormHelperText className="MuiFormHelperText-contained">
                {errors.contactNumber}
              </FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            {renderTextField(
              "contactEmail",
              "Contact Email Address",
              "contactEmail",
              "email",
              false
            )}
          </Grid>
        </Grid>

        {values.type === "delivery" && (
          <>
            {renderTextField("landmark", "Landmark", "landmark", "text", false)}

            <LocationAutocomplete
              value={values.location}
              error={errors.location}
              onChange={(obj) => {
                setValues((prevValues) => ({
                  ...prevValues,
                  ...obj,
                }));
              }}
            />
          </>
        )}

        <Button
          type="submit"
          disableElevation
          variant="contained"
          fullWidth
          className={classes.submit}
        >
          Save Order
        </Button>
      </form>
    </Loader>
  );
}

export default MainLayout(NewDelivery, true);
